import { useSelector } from 'react-redux';

import type { Facet } from '../interfaces/facets';
import { selectCustomFacets } from '../selectors/customFacets';

export const useCustomFacet = (
  attributeName: string,
): {
  name: string;
  value: Facet | undefined;
} => {
  const customFacets = useSelector(selectCustomFacets);

  return {
    name: attributeName,
    value: customFacets && customFacets[attributeName],
  };
};
